import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { SharedService } from "../../component/shared/shared.service";
import { User } from "../../section/user/model/user";
import {
  UserDetail,
  PaymentModeOption,
  DashboardData
} from "../../section/user/model/user-detail";
import { Patient } from "../../section/patient/model/patient";
import { PatientService } from "../../section/patient/service/patient-service.service";
import { UserService } from "../../section/user/service/user.service";
import {
  Appointment,
  Schedule
} from "../../section/appointment/model/appointment";
import { AppointmentService } from "../../section/appointment/service/appointment.service";
import {
  DialogAction,
  ActionMessage
} from "../../shared/enum/dialog-action.enum";
import { Router } from "@angular/router";
import { UtilityService } from "../../section/appointment/calendar/utility.service";
@Component({
  selector: "app-dashboard",
  templateUrl: "./dashboard.component.html",
  styleUrls: ["./dashboard.component.css"]
})
export class DashboardComponent implements OnInit {
  schedulrloading: boolean = false;
  scheduleData: Schedule[];
  selectedType: object;
  usrData: User;
  taskAvailable: object;
  loading: boolean = false;
  listLoading: boolean = false;
  message: string = "";
  appointment: Appointment;
  appointments: Appointment[];
  appointmentsUp: Appointment[];
  data: any[];
  isAdmin = false;
  UsersData: User[];
  selectedAppObject: Appointment;
  isSuccessMessage: boolean = false;
  isErrorMessage: boolean = false;
  apploading: boolean = false;
  Users: User[];
  selectedObject: User;
  patientsData: Patient[];
  patientData: Patient;
  isAdd: boolean = true;
  userClinic = null;
  appDate: any;
  id: number;
  private sub: any;
  user: any;
  doctors: UserDetail[] = [];
  bdas: UserDetail[] = [];
  cancelPTOrder: any[];
  cancelDCOrder: any[];
  isExpertViewed = false;
  isUserCancel = false;
  isExpertCancel = false;
  paymentMode: PaymentModeOption;
  dashboardData: DashboardData;
  constructor(
    private _sharedService: SharedService,
    private _usrService: UserService,
    private _appService: AppointmentService,
    private _ptSrv: PatientService,
    private router: Router,
    private _utility: UtilityService
  ) {
    let dt = new Date();
    this.appDate = {
      date: {
        year: dt.getFullYear(),
        month: dt.getMonth() + 1,
        day: dt.getDate()
      }
    };

    this.appointment = new Appointment(
      null,
      null,
      "",
      null,
      "",
      null,
      "",
      null,
      "",
      "",
      null,
      "",
      "",
      "",
      null,
      "",
      false,
      "",
      false,
      "",
      "",
      "",
      "",
      "",
      false,
      false,
      "",
      0.0
    );
  }

  ngOnInit() {
    this.getPaymentMode();
    this.GetPTRefundCancel();
    this.GetDocRefundCancel();
    this.getDashboardData();
    //if(sessionStorage.getItem("data") == undefined) {
    // this.getPatients();
    //} else {
    // this.router.navigate(['main/appointment/viewappointment']);
    //}
    var dData = new Date();
    let m = dData.getMonth() + 1;
    var mon = m.toString();
    if (m < 10) {
      mon = "0" + mon;
    }
    let d = dData.getDate();
    var cDate = d.toString();
    if (d < 10) {
      cDate = "0" + cDate;
    }

    let startDate = dData.getFullYear() + "-" + mon + "-" + cDate;
    dData.setDate(dData.getDate() + 7);
    m = dData.getMonth() + 1;
    mon = m.toString();
    if (m < 10) {
      mon = "0" + mon;
    }
    d = dData.getDate();
    cDate = d.toString();
    if (d < 10) {
      cDate = "0" + cDate;
    }
    let endDate = dData.getFullYear() + "-" + mon + "-" + cDate;
    this.user = JSON.parse(sessionStorage.getItem("User"));
    if (this.user === undefined || this.user === null) {
      this.getUserDetail(startDate);
    } else {
      if (this.user.UserRoleId == 4) {
        this.getBDAUser();
      } else if (this.user.UserRoleId == 1 || this.user.UserRoleId == 2) {
        let month = new Date();
        this.getAppointmentForMonth(month.getMonth() + 1, month.getFullYear());
        this.getAppointmentForDay(startDate);
        if (this.user.UserRoleId == 1) {
          this.isAdmin = true;
        }
      }
    }
    //

    this.getUsers();
  }

  getBDAUser() {
    this._usrService.getDoctorDetailsByRole().subscribe(data => {
      this.doctors = data.filter(item => item.UserRoleId == 2);
      this.bdas = data.filter(item => item.UserRoleId == 4);
    });
  }

  setPaymentMode() {
    this._usrService.setPaymentModeOption().subscribe(data => {
      this.getPaymentMode();
    });
  }

  getDashboardData() {
    this._usrService.getDashboardData().subscribe(data => {
      this.dashboardData = data;
    });
  }

  getPaymentMode() {
    this._usrService.getPaymentModeOption().subscribe(data => {
      this.paymentMode = data;
    });
  }

  showAppointment(app: UserDetail) {
    this.apploading = true;
    this._appService.GetBDAMonthlySummary(app.UserId).subscribe(
      data => {
        this.data = data;
        this.patientsData = [];
        var ptData: any[] = [];
        /*for(let i=0; i<this.appointments.length; i++) {
         if(ptData.indexOf(this.appointments[i].AppointmentPatientName)==-1) {
           this.patientData = new Patient(this.appointments[i].AppointmentPatientId,this.appointments[i].AppointmentPatientName.split(' ')[0],this.appointments[i].AppointmentPatientName.split(' ')[1],'','',null,'','','','','',this.appointments[i].AppointmentPatientContactNo,null,'',null,this.appointments[i].AppointmentPatientMail,'','','',null,null,'');
           ptData.push(this.appointments[i].AppointmentPatientName);
           this.patientsData.push(this.patientData);

         }
      }*/
        this.apploading = false;
      },
      error => {}
    );
  }
  getUsers(): void {
    this.loading = true;
    this._usrService.getNotViewedUsers().subscribe(
      data => {
        this.loading = false;

        this.UsersData = data;
        console.log(this.UsersData);
      },
      error => {
        this.loading = false;
        this.message = error.data;
      }
    );
  }
  getUserDetail(startDate: string) {
    this._usrService.getUserProfile().subscribe(
      data => {
        if (data.length > 0) {
          this.user = data[0];
          sessionStorage.setItem("User", JSON.stringify(data[0]));
          if (this.user.UserRoleId == 4) {
            this.getBDAUser();
          } else if (this.user.UserRoleId == 1 || this.user.UserRoleId == 2) {
            let month = new Date();
            this.getAppointmentForMonth(
              month.getMonth() + 1,
              month.getFullYear()
            );
            this.getAppointmentForDay(startDate);
          }
        }
      },
      error => {}
    );
  }

  UpdateNotViewed(data: User) {
    this.isExpertViewed = false;
    this._usrService.data = data;
    this._usrService.updateNotViewed().subscribe(data => {
      this.isExpertViewed = true;
      setTimeout(() => {
        this.isExpertViewed = false;
      }, 3000);
      this.getUsers();
    });
  }
  ngAfterViewChecked() {
    this._sharedService.emitChange(false);
  }
  ngOnDestroy() {
    this._sharedService.emitChange(true);
  }
  getAppointmentForDay(date: string): void {
    this.apploading = true;
    this._appService.getUpcoming7Days(date).subscribe(
      data => {
        this.appointmentsUp = data;
        this.patientsData = [];
        var ptData: any[] = [];
        /*for(let i=0; i<this.appointments.length; i++) {
          if(ptData.indexOf(this.appointments[i].AppointmentPatientName)==-1) {
            this.patientData = new Patient(this.appointments[i].AppointmentPatientId,this.appointments[i].AppointmentPatientName.split(' ')[0],this.appointments[i].AppointmentPatientName.split(' ')[1],'','',null,'','','','','',this.appointments[i].AppointmentPatientContactNo,null,'',null,this.appointments[i].AppointmentPatientMail,'','','',null,null,'');
            ptData.push(this.appointments[i].AppointmentPatientName);
            this.patientsData.push(this.patientData);

          }
       }*/
        this.apploading = false;
      },
      error => {}
    );
  }
  getPatients(): void {
    this.loading = true;
    this._ptSrv.getPatients().subscribe(
      data => {
        sessionStorage.setItem("data", JSON.stringify(data));
        this.router.navigate(["main/appointment/viewappointment"]);
      },
      error => {
        this.loading = false;
        this.message = error.data;
      }
    );
  }
  joinAppointment(app: Appointment) {
    /*let d = new Date();
    let appD = new Date(app.AppointmentDay + " "+ app.AppointmentTime);
    var diff =(appD.getTime() - d.getTime()) / 1000;
    diff /= 60;
    let difference= Math.round(diff);
    */
    this._appService
      .isValidTimeForAppointment(app.OrderNo, app.AppointmentPatientId)
      .subscribe(data => {
        if (data.IsAvailable == "1") {
          this.router.navigate(["main/video/videoconfrence", app.OrderNo]);
        } else {
          alert(
            "You can join the appointment at appointment time. You get a max. time of 29.5mins. to join after the appt. starts."
          );
        }
      });
  }
  getAppointmentForMonth(month: number, year: number) {
    let startDate = year.toString() + "-" + month.toString() + "-01";
    var lastDay = new Date(year, month, 0);
    let endDate =
      year.toString() +
      "-" +
      (lastDay.getMonth() + 1).toString() +
      "-" +
      lastDay.getDate();
    this.taskAvailable = { Days: [] };
    this.appointment.AppointmentDoctorId = this.user.UserId;
    if (
      this.appointment.AppointmentDoctorId != null &&
      this.appointment.AppointmentDoctorId != 0
    ) {
      if (this.appointment.AppointmentClinicId == null) {
        this.appointment.AppointmentClinicId = 0;
      }
      this._appService
        .getDoctorAppointmentForDateRange(
          this.appointment.AppointmentDoctorId,
          this.appointment.AppointmentClinicId,
          startDate,
          endDate
        )
        .subscribe(
          data => {
            this.appointments = data;
            var event: any[] = [];
            this.appointments.forEach(element => {
              event.push({
                TaskId: element.AppointmentPatientId,
                TaskName: element.AppointmentPatientName,
                Time: element.AppointmentTime,
                date: element.AppointmentDay,
                Color: element.DoctorColorCode
              });
            });
            var taskList = [];
            let list = event
              .map(item => item.date)
              .filter((value, index, self) => self.indexOf(value) === index);
            for (let taskItem of list) {
              let tasks = event.filter(days => days.date === taskItem);
              taskList.push({
                date:
                  taskItem.split("-")[2] +
                  "-" +
                  this._utility.monthShortNames[
                    parseInt(taskItem.split("-")[1]) - 1
                  ] +
                  "-" +
                  taskItem.split("-")[0],
                tasks: tasks
              });
            }
            this.taskAvailable = { Days: taskList };
            this.schedulrloading = false;
            this.message = "";
          },
          error => {
            this.schedulrloading = false;
          }
        );
    } else {
      this._appService.getDoctorAppointment(startDate, endDate).subscribe(
        data => {
          this.appointments = data;
          var event: any[] = [];
          this.appointments.forEach(element => {
            event.push({
              TaskId: element.AppointmentPatientId,
              TaskName: element.AppointmentPatientName,
              Time: element.AppointmentTime,
              date: element.AppointmentDay,
              Color: element.DoctorColorCode
            });
          });
          var taskList = [];
          let list = event
            .map(item => item.date)
            .filter((value, index, self) => self.indexOf(value) === index);
          for (let taskItem of list) {
            let tasks = event.filter(days => days.date === taskItem);
            taskList.push({
              date:
                taskItem.split("-")[2] +
                "-" +
                this._utility.monthShortNames[
                  parseInt(taskItem.split("-")[1]) - 1
                ] +
                "-" +
                taskItem.split("-")[0],
              tasks: tasks
            });
          }
          this.taskAvailable = { Days: taskList };
          this.schedulrloading = false;
          this.message = "";
        },
        error => {
          this.schedulrloading = false;
        }
      );
    }
  }

  getAppointmentFoDay(date: string) {
    this.appointment.AppointmentDoctorId = this.user.UserId;
    if (
      this.appointment.AppointmentDoctorId != null &&
      this.appointment.AppointmentDoctorId != 0
    ) {
      if (this.appointment.AppointmentClinicId == null) {
        this.appointment.AppointmentClinicId = 0;
      }
      this._appService
        .getDoctorAppointmentForDateRange(
          this.appointment.AppointmentDoctorId,
          this.appointment.AppointmentClinicId,
          date,
          date
        )
        .subscribe(
          data => {
            this.appointments = data;
            var event: any[] = [];
            this.appointments.forEach(element => {
              event.push({
                TaskId: element.AppointmentPatientId,
                TaskName: element.AppointmentPatientName,
                Time: element.AppointmentTime,
                Color: element.DoctorColorCode
              });
            });

            this.taskAvailable = {
              Days: [
                {
                  date:
                    date.split("-")[2] +
                    "-" +
                    this._utility.monthShortNames[
                      parseInt(date.split("-")[1]) - 1
                    ] +
                    "-" +
                    date.split("-")[0],
                  tasks: event
                }
              ]
            };
            this.schedulrloading = false;
            this.message = "";
          },
          error => {
            this.taskAvailable = {
              Days: [
                {
                  date:
                    date.split("-")[2] +
                    "-" +
                    this._utility.monthShortNames[
                      parseInt(date.split("-")[1]) - 1
                    ] +
                    "-" +
                    date.split("-")[0],
                  tasks: []
                }
              ]
            };
          }
        );
      this.getScheduleForDays(date, date);
    } else {
      this._appService.getDoctorAppointment(date, date).subscribe(
        data => {
          this.appointments = data;
          var event: any[] = [];
          this.appointments.forEach(element => {
            event.push({
              TaskId: element.AppointmentPatientId,
              TaskName: element.AppointmentPatientName,
              Time: element.AppointmentTime,
              Color: element.DoctorColorCode
            });
          });

          this.taskAvailable = {
            Days: [
              {
                date:
                  date.split("-")[2] +
                  "-" +
                  this._utility.monthShortNames[
                    parseInt(date.split("-")[1]) - 1
                  ] +
                  "-" +
                  date.split("-")[0],
                tasks: event
              }
            ]
          };
          debugger;
          this.schedulrloading = false;
          this.message = "";
        },
        error => {
          this.taskAvailable = {
            Days: [
              {
                date:
                  date.split("-")[2] +
                  "-" +
                  this._utility.monthShortNames[
                    parseInt(date.split("-")[1]) - 1
                  ] +
                  "-" +
                  date.split("-")[0],
                tasks: []
              }
            ]
          };
        }
      );
    }
  }

  getAppointmentForWeek(startDate: string, endDate: string) {
    this.appointment.AppointmentDoctorId = this.user.UserId;
    if (
      this.appointment.AppointmentDoctorId != null &&
      this.appointment.AppointmentDoctorId != 0
    ) {
      if (this.appointment.AppointmentClinicId == null) {
        this.appointment.AppointmentClinicId = 0;
      }
      this._appService
        .getDoctorAppointmentForDateRange(
          this.appointment.AppointmentDoctorId,
          this.appointment.AppointmentClinicId,
          startDate,
          endDate
        )
        .subscribe(
          data => {
            this.appointments = data;
            var event: any[] = [];
            this.appointments.forEach(element => {
              event.push({
                TaskId: element.AppointmentPatientId,
                TaskName: element.AppointmentPatientName,
                Time: element.AppointmentTime,
                date: element.AppointmentDay,
                Color: element.DoctorColorCode
              });
            });
            var taskList = [];
            let list = event
              .map(item => item.date)
              .filter((value, index, self) => self.indexOf(value) === index);
            for (let taskItem of list) {
              let tasks = event.filter(days => days.date === taskItem);
              taskList.push({
                date:
                  taskItem.split("-")[2] +
                  "-" +
                  this._utility.monthShortNames[
                    parseInt(taskItem.split("-")[1]) - 1
                  ] +
                  "-" +
                  taskItem.split("-")[0],
                tasks: tasks
              });
            }
            this.taskAvailable = { Days: taskList };
            this.schedulrloading = false;
            this.message = "";
          },
          error => {
            this.schedulrloading = false;
          }
        );
      this.getScheduleForDays(startDate, endDate);
    } else {
      this._appService.getDoctorAppointment(startDate, endDate).subscribe(
        data => {
          this.appointments = data;
          var event: any[] = [];
          this.appointments.forEach(element => {
            event.push({
              TaskId: element.AppointmentPatientId,
              TaskName: element.AppointmentPatientName,
              Time: element.AppointmentTime,
              date: element.AppointmentDay,
              Color: element.DoctorColorCode
            });
          });
          var taskList = [];
          let list = event
            .map(item => item.date)
            .filter((value, index, self) => self.indexOf(value) === index);
          for (let taskItem of list) {
            let tasks = event.filter(days => days.date === taskItem);
            taskList.push({
              date:
                taskItem.split("-")[2] +
                "-" +
                this._utility.monthShortNames[
                  parseInt(taskItem.split("-")[1]) - 1
                ] +
                "-" +
                taskItem.split("-")[0],
              tasks: tasks
            });
          }
          this.taskAvailable = { Days: taskList };
          this.schedulrloading = false;
          this.message = "";
        },
        error => {
          this.schedulrloading = false;
        }
      );
    }
  }

  showHistory(appId: number) {
    window.open(
      "https://www.theaurapower.com/Patient/History?AppointmentId=" + appId,
      "_blank",
      "width:100%"
    );
  }

  getdata(data: any) {
    if (data.type == "M") {
      this.getAppointmentForMonth(
        data.selected.split("/")[0],
        data.selected.split("/")[1]
      );
    } else if (data.type == "W") {
      this.getAppointmentForWeek(
        data.selected.split(" ")[0],
        data.selected.split(" ")[1]
      );
    } else {
      this.getAppointmentFoDay(data.selected);
    }
    this.selectedType = data;
  }

  getScheduleForDays(startDate: string, endDate: string) {
    if (
      this.appointment.AppointmentDoctorId != null &&
      this.appointment.AppointmentDoctorId != 0
    ) {
      let clinic = 0;
      if (this.appointment.AppointmentClinicId == null) {
        clinic = 0;
      } else {
        clinic = this.appointment.AppointmentClinicId;
      }
      this._appService
        .getDoctorScheduleForMultipleDay(
          this.appointment.AppointmentDoctorId,
          clinic,
          startDate,
          endDate
        )
        .subscribe(
          data => {
            this.scheduleData = data;
          },
          error => {}
        );
    }
  }

  GetPTRefundCancel() {
    this._appService.GetCancelRefund("PT").subscribe(
      data => {
        this.cancelPTOrder = data;
      },
      error => {}
    );
  }
  GetDocRefundCancel() {
    this._appService.GetCancelRefund("DC").subscribe(
      data => {
        this.cancelDCOrder = data;
      },
      error => {}
    );
  }

  ApproveCancellation(id: number, type: string) {
    this.isUserCancel = false;
    this.isExpertCancel = false;
    this._appService.ApproveCancelOrder(id).subscribe(
      data => {
        if (type == "PT") {
          this.isUserCancel = true;
          this.GetPTRefundCancel();
        } else {
          this.isExpertCancel = true;
          this.GetDocRefundCancel();
        }

        setTimeout(() => {
          this.isUserCancel = false;
          this.isExpertCancel = false;
        }, 3000);
      },
      error => {}
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/component/dashboard/dashboard.component.ts